import React, { useEffect, useRef, useState } from 'react'
import "./index.css"
import { BellIcon, CartEventIcon, UpDownArrowIcon } from '../../../../components/GlobalIcons';
import OutsideClick from '../../../../components/OutsideClick';
import CartPrice from '../EventTicketDetail/CartPrice';
import { HiMiniBellAlert } from 'react-icons/hi2';
import { DEFAULT_CURRENCY } from '../../../../constants';
import { moneyRoundOff } from '../../../../utils/func';
import { ADD_WATCHLIST_API } from '../../../../APIs';
import Swal from 'sweetalert2';
import { sweetAlertToast } from '../../../../utils/sweetAlert2';
import { toast } from 'react-toastify';

const TicketContent = ({ item, onHoverCatIdFromEvent, checkForWishListStatus, getHoverOnBasedOfTicket, ticketData, onHoverCatIDFromSvg, reservationData, ticektindex, cartIndex, setOnHoverCatIdFromEvent, priceTicketCategoryIndex, pricePopuUpIndex, setPricePopUpIndex, handlerSetWhislist, setPriceTicketCategoryIndex, reserveTicket, event,
  showNotifyPopUp, setShowNotifyPopUp

}) => {
  const [watchListStatus, setWatchListStatus] = useState(false)
  const closeRef = useRef();

  useEffect(() => {
    setWatchListStatus(checkForWishListStatus)
  }, [checkForWishListStatus])

  const customSort = (items) => {
    return items.sort((a, b) => a.net_rate_inr - b.net_rate_inr);
  };

  const closePriceCart = () => {
    setPricePopUpIndex();
    setPriceTicketCategoryIndex();
    // reserveTicket(reservationData)
  };

  const togglePriceCart = (categoryIndex, ticketIndex) => {
    if (
      ticketIndex === pricePopuUpIndex &&
      categoryIndex === priceTicketCategoryIndex
    ) {
      setPricePopUpIndex();
      setPriceTicketCategoryIndex();
    } else {
      setPricePopUpIndex(ticketIndex);
      setPriceTicketCategoryIndex(categoryIndex);
    }
  };

  const handleFetchAllQuantityFromcategory = (catId, eventName) => {
    const categoryItems = reservationData?.filter(item => (item.categoryId === catId && item?.ticketName === eventName));
    if (categoryItems.length > 0) {
      const totalQuantity = categoryItems.reduce((total, item) => total + item.quantity, 0);
      return totalQuantity;
    } else {
      return "Add";
    }
  };



  const handleAddToWatchList = async () => {
    if (watchListStatus) {
      return true
    }
    const eventDetail = item?.[1]?.[0]
    try {
      const payload = {
        category_id: eventDetail?.category_id,
        event_id: eventDetail?.event_id
      }
      const response = await ADD_WATCHLIST_API(payload)
      if (response && response?.status) {
        setWatchListStatus(true)
        toast.success(response?.message)
      } else {
        toast.error(response?.message)
      }
    } catch (error) {
      console.log(error, "ADD_WATCHLIST_API")
    }
  }

  return (
    <div className={`ticket_detail_content ${(onHoverCatIdFromEvent && onHoverCatIdFromEvent === item?.[1]?.[0]?.category_id) ? "selectedHover" : getHoverOnBasedOfTicket(event[0], ticketData, onHoverCatIDFromSvg) ? "selectedHover" : ""}`} key={cartIndex} onMouseEnter={() => setOnHoverCatIdFromEvent(item?.[1]?.[0]?.category_id)} onMouseLeave={() => setOnHoverCatIdFromEvent("")} >
      <h3>
        {item[0]}
        <span
          onClick={() => {
            handleAddToWatchList()
          }}
          title={watchListStatus ? "Remove from watchlist" : "Add to watchlist"}
        >
          {
            watchListStatus ? <HiMiniBellAlert />
              :
              <BellIcon />

          }
        </span>
      </h3>
      <h4>{`${DEFAULT_CURRENCY} ${moneyRoundOff(
        customSort(item[1])[0].net_rate_inr
      )}`}</h4>
      <div
        className="cart_of_events"
        style={{ position: "relative" }}
        ref={
          pricePopuUpIndex === cartIndex &&
            priceTicketCategoryIndex === ticektindex
            ? closeRef
            : null
        }
      >
        <button
        className='addCart'
          onClick={() =>
            pricePopuUpIndex?.length > 0
              ? ""
              : togglePriceCart(ticektindex, cartIndex)
          }
        >
          <span>
            <CartEventIcon />
          </span>{" "}
          {handleFetchAllQuantityFromcategory(item?.[1]?.[0]?.category_id, item[0])}
          <span>
            <UpDownArrowIcon />
          </span>
          <OutsideClick
            closeRef={closeRef}
            func={closePriceCart}
            state={pricePopuUpIndex}
          />
        </button>

        <div
          className={`cart_priceing_sec ${pricePopuUpIndex === cartIndex &&
            priceTicketCategoryIndex === ticektindex
            ? "active"
            : ""
            }`}
        >
          {pricePopuUpIndex === cartIndex &&
            priceTicketCategoryIndex === ticektindex ? (
            <CartPrice items={customSort(item[1])} ticketName={item[0]} reserveTicket={reserveTicket} showNotifyPopUp={showNotifyPopUp} setShowNotifyPopUp={setShowNotifyPopUp}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  )
}

export default TicketContent;